import {Component, OnInit} from '@angular/core';
import {BaseCustomDialog} from "../base-custom-dialog";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'fi-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.scss'],
  standalone: false,
})
export class GeneralErrorComponent extends BaseCustomDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GeneralErrorComponent>,
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
  }

  onClosePopup(): void {
    this.clearClassAndCloseDialog(this.dialogRef);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClosePopup();
    }
  }

}
